import { Accordion, Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { formatMoeda, rgx_numberOnly } from "../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import auxService from "../../services/AuxService";
import { MakeMessageError } from "../../components/Components";
import { EstadoInterface, MunicipioInterface } from "../../interfaces";
import ReactInputMask from "react-input-mask";
import { TermoUsoModal } from "../assinatura/TermoUsoModal";

const initialFieldsError = {
    comprador_cpfcnpj: [],
    comprador_nome: [],
    name: [],
    cpfcnpj: [],
    xfant: [],
    xlgr: [],
    nro: [],
    cep: [],
    xcpl: [],
    xbairro: [],
    estado_id: [],
    municipio_id: [],
    fone: [],
    celular: [],
    ie: []
}

export default function FormLicenca() {
    const [valorMensalidade, setValorMensalidade] = useState<number>(0);
    const [errors, setErrors] = useState(initialFieldsError);
    const btnGerarQrCode = useRef<HTMLButtonElement | null>(null);
    const btnVoltar = useRef<HTMLAnchorElement | null>(null);
    const navigate = useNavigate();
    const [municipios, setMunicipios] = useState<MunicipioInterface[]>([]);
    const [estados, setEstados] = useState<EstadoInterface[]>([{
        id: 0,
        uf: 'Selecione',
        name: 'Selecione',
        cod_ibge: 0,
        pais: { name: 'Brasil' }

    }]);
    const [assinatura, setAssinatura] = useState({
        id: 0,
        valor: 0,
        quantidade_meses_restante: 0,
        valor_anual: 0,
        valor_mensal: 0
    });

    const municipioRef = useRef<HTMLSelectElement>(null);

    const [form, setForm] = useState({
        comprador_nome: '',
        comprador_cpfcnpj: '',
        valor: '',
        aceite: false,
        name: '',
        cpfcnpj: '',
        ie: '',
        xfant: '',
        xlgr: '',
        nro: '',
        xbairro: '',
        cep: '',
        xcpl: '',
        estado_id: 0,
        municipio_id: 0,
        fone: '',
        celular: '',
    });

    const handleChangeEstado = (e: any) => {
        const { name, value } = e.target;
        municipioRef.current?.setAttribute('disabled', '');

        setErrors({
            ...errors,
            [name]: "",
            municipio_id: []
        })

        if (value > 0) {
            auxService.getMunicipios(value).then(data => {

                if (data?.length > 0) {
                    setMunicipios(data)
                    setForm((prev) => ({
                        ...prev,
                        municipio_id: data.filter((municipio: MunicipioInterface) => municipio.capital === 1)[0]?.id || 0
                    }))
                    municipioRef.current?.removeAttribute('disabled');
                }
            }).catch(err => {
                municipioRef.current?.removeAttribute('disabled');
            })
        } else {
            municipioRef.current?.setAttribute('disabled', '');

            setMunicipios([])
            setForm((prev) => ({
                ...prev,
                municipio_id: 0
            }))
        }

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: "" }));


        const transformers: Record<string, (val: string) => string> = {
            cpfcnpj: rgx_numberOnly,
            cnpj: rgx_numberOnly,
            ie: rgx_numberOnly,
        };

        const newValue = transformers[name] ? transformers[name](value) : value;

        setForm({ ...form, [name]: newValue });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        desabilitaButtonFooter();

        auxService.postComprarLicenca(form)
            .then(res => {
                desabilitaButtonFooter(false);
                navigate('/qrcode', {
                    state: {
                        qrcode: res.data.qrcode,
                        image: res.data.image,
                        documento: res.data.documento,
                        valor: res.data.valor,
                        tipo: 'licenca'
                    }
                });
            })
            .catch(error => {
                desabilitaButtonFooter(false);

                if (error.response) {
                    if (error.response.status === 422) {
                        setErrors(error.response.data);
                    }
                }
            })
    };

    const desabilitaButtonFooter = (status = true) => {

        if (status) {

            if (btnGerarQrCode.current) {
                btnGerarQrCode.current.disabled = true;
            }

            if (btnVoltar.current) {
                btnVoltar.current.style.pointerEvents = 'none';
                btnVoltar.current.style.opacity = '0.5';
                btnVoltar.current.style.cursor = 'not-allowed';
            }
        } else {

            if (btnGerarQrCode.current) {
                btnGerarQrCode.current.disabled = false;
            }

            if (btnVoltar.current) {
                btnVoltar.current.style.pointerEvents = 'auto';
                btnVoltar.current.style.opacity = '1';
                btnVoltar.current.style.cursor = 'pointer';
            }
        }
    }
    useEffect(() => {
        auxService.getAssinaturaLicenca().then(res => {
            setForm({ ...form, valor: formatMoeda(res.valor) });
            setValorMensalidade(res.valor);

            setAssinatura({
                id: res.id,
                valor: res.valor,
                quantidade_meses_restante: res.quantidade_meses_restante,
                valor_anual: res.valor_anual,
                valor_mensal: res.valor_mensal
            })
        })
            .catch(error => console.log(error));

        auxService.getEstados().then(data => {
            setEstados([...estados, ...data])
        })
        municipioRef.current?.setAttribute('disabled', '');
    }, []);
    const [aceite, setAceite] = useState<boolean>(false);
    const [showTermo, setShowTermo] = useState<boolean>(false);

    const handleAceite = () => {
        setAceite(true);
        setForm({ ...form, aceite: true });
        setShowTermo(false);

    }

    return (<div className="d-flex justify-content-center align-items-center py-2">
        <div className="row col-md mx-auto">
            {showTermo && (

                <TermoUsoModal
                    show={showTermo}
                    aceite={aceite}
                    onHide={() => setShowTermo(false)}
                    handleAceite={handleAceite} />
            )}

            <Form onSubmit={handleSubmit}>
                <Card className="card-primary card-outline">
                    <Card.Header className="d-flex justify-content-between">
                        {aceite && (
                            <div>
                                <Button variant="primary" type="submit" ref={btnGerarQrCode} disabled={!aceite}>
                                    <FontAwesomeIcon icon={faQrcode} /> Gerar pagamento
                                </Button>
                            </div>
                        )}

                        <div>
                            {!aceite && (
                                <Button variant="success" onClick={() => setShowTermo(true)}>Aceitar termos</Button>
                            )}
                        </div>
                        <div>
                            <Link to="/licenca" className="btn btn-secondary me-2" ref={btnVoltar}>
                                <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                            </Link>
                        </div>

                    </Card.Header>

                    <Card.Body>
                        <Card className="mb-2">
                            <Card.Header>Dados do comprador</Card.Header>
                            <Card.Body>
                                <Row className="g-2">
                                    <Col md>
                                        <Form.Group className="mb-2" controlId="comprador_nome">
                                            <Form.Label>* Nome</Form.Label>
                                            <Form.Control type="text" maxLength={60}
                                                className={`${errors.comprador_nome?.length > 0 ? "is-invalid" : ""}`}
                                                autoFocus value={form.comprador_nome}
                                                onChange={handleChange} name="comprador_nome" />
                                            <MakeMessageError errors={errors} field="comprador_nome" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-2" controlId="comprador_cpfcnpj">
                                            <Form.Label>* CPF/CNPJ</Form.Label>
                                            <Form.Control type="text" maxLength={14}
                                                value={form.comprador_cpfcnpj} onChange={handleChange}
                                                className={`${errors.comprador_cpfcnpj?.length > 0 ? "is-invalid" : ""}`}
                                                name="comprador_cpfcnpj" />
                                            <MakeMessageError errors={errors} field="comprador_cpfcnpj" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-2 text-end" controlId="valor">
                                            <Form.Label >Valor Proporcional</Form.Label>
                                            <Form.Control type="text" disabled className="text-end"
                                                name="valor" value={form.valor} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>

                        <Card className="mb-2">
                            <Card.Header>
                                Dados da filial
                            </Card.Header>
                            <Card.Body>
                                <Row className="g-2">
                                    <Col md>
                                        <Form.Group className="mb-2" controlId="name">
                                            <Form.Label>* Nome da razão social:</Form.Label>
                                            <Form.Control type="text" name="name"
                                                value={form.name}
                                                className={`${errors.name?.length > 0 ? "is-invalid" : ""}`}

                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="name" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group className="mb-2" controlId="xfant">
                                            <Form.Label>Nome fantasia:</Form.Label>
                                            <Form.Control type="text" name="xfant"
                                                value={form.xfant}
                                                className={`${errors.xfant?.length > 0 ? "is-invalid" : ""}`}

                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="xfant" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-2" controlId="cpfcnpj">
                                            <Form.Label>* CNPJ:</Form.Label>
                                            <Form.Control type="text" name="cpfcnpj"
                                                value={form.cpfcnpj}
                                                className={`${errors.cpfcnpj?.length > 0 ? "is-invalid" : ""}`}

                                                maxLength={14}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="cpfcnpj" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group className="mb-2" controlId="ie">
                                            <Form.Label>* Inscrição Estadual:</Form.Label>
                                            <Form.Control type="text" name="ie"
                                                value={form.ie}
                                                className={`${errors.ie?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={14}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="ie" />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="g-2">
                                    <Col md>
                                        <Form.Group className="mb-2" controlId="xlgr">
                                            <Form.Label>* Endereço:</Form.Label>
                                            <Form.Control type="text" name="xlgr"
                                                value={form.xlgr}
                                                className={`${errors.xlgr?.length > 0 ? "is-invalid" : ""}`}

                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="xlgr" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-2" controlId="nro">
                                            <Form.Label>* Número:</Form.Label>
                                            <Form.Control type="text" name="nro"
                                                value={form.nro}
                                                className={`${errors.nro?.length > 0 ? "is-invalid" : ""}`}

                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="nro" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group className="mb-2" controlId="cep">
                                            <Form.Label>* CEP:</Form.Label>
                                            <Form.Control type="text" name="cep"
                                                value={form.cep}
                                                className={`${errors.cep?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={8}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="cep" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="g-2">

                                    <Col md>
                                        <Form.Group className="mb-2" controlId="xcpl">
                                            <Form.Label>Complemento:</Form.Label>
                                            <Form.Control type="text" name="xcpl"
                                                value={form.xcpl}
                                                className={`${errors.xcpl?.length > 0 ? "is-invalid" : ""}`}

                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="xcpl" />
                                        </Form.Group>
                                    </Col>

                                    <Col md>
                                        <Form.Group className="mb-2" controlId="xbairro">
                                            <Form.Label>* Bairro:</Form.Label>
                                            <Form.Control type="text" name="xbairro"
                                                value={form.xbairro}
                                                className={`${errors.xbairro?.length > 0 ? "is-invalid" : ""}`}

                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="xbairro" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-2" controlId="fone">
                                            <Form.Label>Telefone:</Form.Label>
                                            <ReactInputMask mask="(99)9999-9999" name="fone"
                                                className={`form-control  ${errors.fone?.length > 0 ?
                                                    "is-invalid" : ""}`
                                                }
                                                value={form.fone}
                                                onChange={handleChange}
                                            />
                                            <MakeMessageError errors={errors} field="fone" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-2" controlId="celular">
                                            <Form.Label>* Celular:</Form.Label>
                                            <ReactInputMask mask="(99)99999-9999" name="celular"
                                                className={`form-control  ${errors.celular?.length > 0 ?
                                                    "is-invalid" : ""}`
                                                }
                                                value={form.celular}
                                                onChange={handleChange}
                                            />
                                            <MakeMessageError errors={errors} field="celular" />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row className="g-2">
                                    <Col md={2}>
                                        <Form.Group className="mb-2" controlId="estado_id">
                                            <Form.Label>* Estados</Form.Label>
                                            <Form.Select name="estado_id" value={form.estado_id}
                                                className={`${errors.estado_id?.length > 0 ? "is-invalid" : ""}`}
                                                onChange={handleChangeEstado}>

                                                {estados.map((estado) => (
                                                    <option key={estado.id} value={estado.id}>{estado.uf}</option>
                                                ))}
                                            </Form.Select>
                                            <MakeMessageError errors={errors} field="estado_id" />
                                        </Form.Group>
                                    </Col>


                                    <Col md>
                                        <Form.Group className="mb-2" controlId="municipio_id">
                                            <Form.Label>* Municípios</Form.Label>
                                            <Form.Select name="municipio_id" value={form.municipio_id}
                                                ref={municipioRef}
                                                className={`${errors.municipio_id?.length > 0 ? "is-invalid" : ""}`}
                                                onChange={handleChange}>
                                                {municipios && (
                                                    municipios?.map((municipio) => {
                                                        return <option
                                                            selected={municipio.capital === 1} key={municipio.id}
                                                            value={municipio.id}>{municipio.name}
                                                        </option>
                                                    })
                                                )}
                                            </Form.Select>
                                            <MakeMessageError errors={errors} field="municipio_id" />
                                        </Form.Group>
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                        <Accordion className="mt-2">
                            <Accordion.Item eventKey="0"  >
                                <Accordion.Header  >
                                    <div className="fw-bold">* Cálculo do valor proporcional</div>
                                </Accordion.Header>
                                <Accordion.Body className="p-2">
                                    <p className="lh-2">
                                        <strong className="lh-2">Valor Anual: </strong>
                                        <span className="text-primary fw-bold lh-2">{formatMoeda(assinatura.valor_anual)}</span>
                                        &nbsp;cobrado na próxima renovação somado a licença principal da matriz e a outras filiais
                                        se houver.
                                    </p>
                                    <p className="lh-2"><strong>(A): Valor mensal: </strong>
                                        <span className="text-primary fw-bold">{formatMoeda(assinatura.valor_mensal)}</span>
                                    </p>
                                    <p className="lh-2"><strong>(B): Quantidade de meses para a proxima renovação: </strong>
                                        <span className="text-primary fw-bold">{assinatura.quantidade_meses_restante}</span>
                                    </p>
                                    <p className="lh-2"><strong>Valor proporcional: </strong>
                                        <span className="text-primary fw-bold">{formatMoeda(assinatura.valor)}</span>
                                        . Equivale ao <strong>(A)</strong>Valor mensal * <strong>(B)</strong>
                                        Quantidade de meses que falta para a próxima renovação. Valor proporcional
                                        mínimo <strong className="text-primary fw-bold">{formatMoeda(assinatura.valor_mensal)}</strong>.
                                    </p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Card.Body>
                </Card>
            </Form>
        </div>
    </div>)
}